module.exports = __webpack_public_path__ + "img/apple-icon-57x57.4eee8bc5.png";